import {
  Error,
  ErrorContainer,
  Input,
  InputContainer,
} from "components/common/inputs/styled";
import { StyledLabel, StyledText } from "components/common/info/styled";
import { MedButton } from "components/common/buttons";
import React from "react";

export class VerifyEmail extends React.Component<{
  value: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: () => Promise<void>;
  error: any;
  success: any;
}> {
  render() {
    return (
      <>
        <InputContainer>
          <StyledText>
            Please enter your email address to get started
          </StyledText>
          <StyledLabel>Email address</StyledLabel>
          <StyledText></StyledText>
          <Input
            type="email"
            value={this.props.value}
            onChange={this.props.onChange}
            placeholder="Enter your email"
          />
        </InputContainer>
        <MedButton
          $coral
          width={23}
          onClick={this.props.onClick}
          disabled={this.props.error !== ""}
        >
          Verify Email
        </MedButton>
        {this.props.error && !this.props.success && (
          <ErrorContainer>
            <Error>{this.props.error}</Error>
          </ErrorContainer>
        )}
      </>
    );
  }
}
